import React from "react";
import App from "components/App";


export default function Main() {
    return (
        <App />
    );
}
